import { useState } from 'react';
import { Add } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import SelectField from 'components/SelectField';
import UserForm from 'forms/UserForm';
import SelectFieldProps from 'types/components/SelectFieldProps';

type EditorSelectorProps = Pick<
  SelectFieldProps,
  | 'name'
  | 'label'
  | 'placeholder'
  | 'value'
  | 'options'
  | 'touched'
  | 'isDisabled'
  | 'error'
  | 'onBlur'
  | 'setFieldValue'
> & {
  reloadUsers?: () => void;
};

export default function EditorSelector({
  name,
  label,
  placeholder,
  value,
  options,
  touched,
  isDisabled,
  error,
  onBlur,
  setFieldValue,
  reloadUsers,
}: EditorSelectorProps): JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 4 }}>
        <div style={{ flex: 1 }}>
          <SelectField
            name={name}
            label={label}
            placeholder={placeholder}
            value={value}
            options={options}
            isMulti={false}
            setFieldValue={setFieldValue}
            onBlur={onBlur}
            touched={touched}
            error={error}
            isClearable={false}
            backspaceRemovesValue={false}
            isDisabled={isDisabled}
            isSearchable={true}
          />
        </div>
        <IconButton aria-label="add user" onClick={handleOpen}>
          <Add />
        </IconButton>
      </div>

      <Modal open={open} handleClose={handleClose} title={t('listUsers-page-create')}>
        <UserForm
          onSuccess={() => {
            if (reloadUsers) reloadUsers();
            handleClose();
          }}
        />
      </Modal>
    </>
  );
}
